/**
 * Resolves when every <img> in the document has loaded or failed.
 * Use before window.print() so logos and other assets appear in the print preview.
 */
export function waitForDocumentImages(doc: Document, timeoutMs = 12000): Promise<void> {
  const images = Array.from(doc.images);
  const pending = images.filter(img => !img.complete);
  if (pending.length === 0) return Promise.resolve();

  return Promise.race<void>([
    Promise.all(
      pending.map(
        img =>
          new Promise<void>(resolve => {
            img.addEventListener('load', () => resolve(), { once: true });
            img.addEventListener('error', () => resolve(), { once: true });
          })
      )
    ).then(() => {}),
    new Promise<void>(resolve => {
      setTimeout(resolve, timeoutMs);
    }),
  ]);
}

/** Two rAFs — lets layout/paint settle before print (helps WebKit). */
export function waitForNextPaint(): Promise<void> {
  return new Promise(resolve => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => resolve());
    });
  });
}
